import { ICombinedReplaceIdStatistic } from '../interfaces/combined-replace-id-statistic.interface';
import ITaskItemDTO = ZoningAPI.ITaskItemDTO;
import * as _ from 'lodash';

export class TaskItemMapper {
    toCombinedReplaceIdStatistic(dto: ITaskItemDTO): ICombinedReplaceIdStatistic {
        if (!dto) {
            return null;
        }

        return {
            id: dto.Id,
            oldId: dto.FolioNumber,
            newId: dto.GridicsId,
            ..._.pick(dto.MetaData as any, [
                'oldIdZCCount',
                'updatedZCRecordsCount',
                'newIdZCCount',
                'oldIdZCVCount',
                'updatedZCVRecordsCount',
                'newIdZCVCount',
                'oldIdPRsPlaceCount',
                'updatedPRsPlaceCount',
                'newIdPRsPlaceCount',
                'oldIdPRsLandUseCount',
                'updatedPRsLandUseCount',
                'newIdPRsLandUseCount',
                'oldIdPRsZoningCodeIdCount',
                'updatedPRsZoningCodeIdCount',
                'newIdPRsZoningCodeIdCount'
            ])
        };
    }
}
